export default __webpack_public_path__ + "static/media/interests.809890a3.svg";